module.exports = __webpack_public_path__ + "static/media/lakers.8f36b909.png";